import * as actions from "./actions";
import { Record } from "immutable";

const InitialState = Record({
  mobileMenuActive: false,
  isShown: true
});
const initialState = new InitialState();

export default function headerResponsiveReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return initialState.mergeDeep(state);
  switch (action.type) {
    case actions.SHOW_MOBILE_MENU: {
      return state.set("mobileMenuActive", action.payload);
    }
    case actions.SET_IS_SHOWN: {
      return state.set("isShown", action.payload);
    }
  }
  return state;
}



/** WEBPACK FOOTER **
 ** ./src/browser/components/HeaderResponsive/reducer.js
 **/